import { environment } from './../../../environments/environment';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { StorageService } from "app/@core/services/storage.service";
import { saveAs } from 'file-saver';
import { IUserRolesResponse } from 'app/shared/interfaces/companyData.interface';

@Injectable()
export class BaseService {
    private shipmentStatusDataSubject = new BehaviorSubject<any>(null);
    shipmentStatusData$ = this.shipmentStatusDataSubject.asObservable();
    private readonly STORAGE_KEY = 'table-settings';
    reloadCoulmn = new Subject();
    // reloadCoulmn = new BehaviorSubject<any>(null);
    gridCount = new Subject();
    tableData = new Subject();
    tableData$ = this.tableData.asObservable();
    public filterSelect2Options = [];
    // ---------------- Newly added for column preset ----------------
    gettingResponse: any = null;
    columnsData = new BehaviorSubject<any>([]);
    columnsData$ = this.columnsData.asObservable();
    presetNameArr: any = [];
    presetNameArrDefault: any = [];
    columnPresetDefault = new BehaviorSubject<any>([]);
    columnPresetDefault$ = this.columnPresetDefault.asObservable();








    public createE4ScoreRoutePath(parentPath: string, completePath: string): any[] {
        const functionList: any[] = JSON.parse(localStorage.getItem("featureFunctionList"));
        const moduleId = localStorage.getItem('moduleId')
        const ezTrackModule = functionList?.find(module => module.moduleId == moduleId);
        const ezTrackParent: any = ezTrackModule?.parents;

        const parentFeature = ezTrackParent?.find(parent => parent.featurePath === parentPath)
        const features: any = parentFeature?.features
        const featureFuncs = features?.find((path) => path.featurePath == completePath);
        const funcs: any[] = featureFuncs?.functions
        return funcs;
    }
    setData(data: string) {
        this.tableData.next(data);
    }

    getTableData(): Observable<any> {
        return this.tableData.asObservable();
    }

    constructor(
        private http: HttpClient,
        private spinner: NgxSpinnerService,
        public storageService: StorageService

    ) { }

    public sendForgotPassword(url): Observable<any> {
        return this.http.post(environment.APIURL + url, {});
    }

    public postRequest(url, body): Observable<any> {

        const tableSettingKey = localStorage.getItem('tableSettingKey');
        let isLoginCall = url.includes('login')
        if (!isLoginCall) {
            let parseData = JSON.stringify(body);
            localStorage.setItem(tableSettingKey, parseData);
        }
        return this.http.post(environment.APIURL + url, body);
    }

    public getRequest(URL: any): Observable<any> {
        return this.http.get(environment.APIURL + URL);
    }

    public putRequest(url, body): Observable<any> {
        return this.http.put(environment.APIURL + url, body);
    }

    public removeRequest(url, UserId?): Observable<any> {
        url = url + `?UserId=${UserId}`
        return this.http.delete(environment.APIURL + url);
    }

    public exportExcel(URL: any, postData): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        return this.http.post(environment.APIURL + URL, postData, { headers, responseType: 'blob' })
    }

    public importExcel(URL: any, postData): Observable<any> {
        return this.http.post(environment.APIURL + URL, postData)
    }

    public getMapData(PageNumber, assetType = 0, assetList, optionalPageSize): Observable<any> {
        const companyId = this.storageService.getCompanyID();
        // const url = `MapData?CompanyId=${companyId}&PageNumber=${PageNumber}&assetType=${assetType}&pageSizeOptional=${optionalPageSize}`
        const url = `MapData`
        let obj = {
            "companyId": companyId,
            "assetType": assetType,
            "pageNumber": PageNumber,
            "pageSizeOptional": optionalPageSize,
            "assetList": assetList
        }
        return this.http.post(environment.APIURL + url, obj);
    }

    userId = localStorage.getItem('userId')

    public getTableSettings1(pageReference): Observable<any> {

        const url = `filter?userId=${this.userId}&page=${pageReference}`;
        return this.http.get(environment.APIURL + url);
    }
/**
 * Get table settings with caching and localStorage management
 */
    getTableSettings(pageReference:any, isHardReload:any): Observable<any> {
      const scopedIsView = localStorage.getItem(this.getIsViewKey(pageReference));
        const fallbackIsView = localStorage.getItem("isViewBool");
        const isViewBool: any = scopedIsView !== null ? scopedIsView : fallbackIsView;

        const scopedJsonColumns = localStorage.getItem(this.getJsonColumnDataKey(pageReference));
        const fallbackJsonColumns = localStorage.getItem("jsonColumnData");
        const jsonColumnData: any = scopedJsonColumns !== null ? scopedJsonColumns : fallbackJsonColumns;

        let isView = false;
        let jsonColumnDataGet: any = undefined;

        if (isViewBool && isViewBool !== "null") {
            try {
                isView = JSON.parse(isViewBool);
            } catch {
                isView = false;
            }
        }

        if (jsonColumnData && jsonColumnData !== "null") {
            try {
                jsonColumnDataGet = JSON.parse(jsonColumnData);
            } catch {
                jsonColumnDataGet = undefined;
            }
        }

        const cachedData = localStorage.getItem(pageReference + '-' + this.STORAGE_KEY);
        let userType = localStorage.getItem("userType");
        let userId: any;
        if (userType === "Company User") {
            userId = localStorage.getItem("companyUserId");
        }
        else {
            userId = null;
        }
        const companyId = localStorage.getItem('companyID')
        if (cachedData && isHardReload) {
            const parsedCacheData = JSON.parse(cachedData);
            const modifiedData = this.handleColumnsSettingResponse(parsedCacheData, pageReference);
            return of(modifiedData);
        } else {
            let obj = {
                "companyId": companyId,
                "userId": userId,
                "page": pageReference,
                "isView": isView,
                "json": jsonColumnDataGet
            }
            const url = 'GetFilter';
            return this.http.post(environment.APIURL + url, obj)
                .pipe(
                    map((response: any) => {
                        this.handleColumnsSettingResponse(response,pageReference);
                        return this.handleColumnsSettingResponse(response,pageReference);;
                    }),
                    catchError(error => of(error))
                );
        }
    }


    handleColumnsSettingResponse(response: any, pageReference: string) {
        var companyNamelocalStorage = localStorage.getItem("companyName")
        if (response.isDefault === true || response.isDefault === false) {
            this.presetNameArrDefault = []

            let obj1 = {
                presetName: pageReference + ' - ' + companyNamelocalStorage,
                isDefault: response.isDefault

            }
            this.presetNameArrDefault.push(obj1)
            this.columnPresetDefault.next(this.presetNameArrDefault);
            localStorage.setItem('presetNameDefault', JSON.stringify(this.presetNameArrDefault));
        }

        this.presetNameArr = []; // Define arr outside the map loop
        response.tablePresetResponses?.map(x => {
            let obj = { // Define obj inside the map loop
                presetName: x.presetName,
                tableFilterId: x.tableFilterId,
                isDefault: x.isDefault
            };
            this.presetNameArr.push(obj);
            x.isDefault// Push obj to arr within the map loop

        });
        this.columnsData.next(this.presetNameArr);
        localStorage.setItem('presetName', JSON.stringify(this.presetNameArr));
        this.gettingResponse = null;

        if (response.isDefault === true) {
            var presetName = "system preset";
            localStorage.setItem("responsePresetName", JSON.stringify(presetName));
            localStorage.setItem(pageReference + '-' + this.STORAGE_KEY, JSON.stringify(response));

            // var parseData = JSON.parse(response.filterJson)
            var parseData = response.filterJson ? JSON.parse(response.filterJson) : '';

            // parseData.presetName = presetName
            localStorage.setItem(pageReference + "-filterJSON", JSON.stringify(parseData));

            this.gettingResponse = response;

        }
        else {
            response.tablePresetResponses?.map(x => {

                if (x.isDefault === true) {

                    var presetName = x.presetName;
                    localStorage.setItem("responsePresetName", JSON.stringify(presetName));
                    if (presetName !== 'Current Session Preset') {
                        localStorage.setItem(pageReference + '-' + this.STORAGE_KEY, JSON.stringify(response));
                    }
                    var parseData = x.filterJson ? JSON.parse(x.filterJson) : '';
                    // Convert back to a JSON string and set in localStorage
                    localStorage.setItem(pageReference + "-filterJSON", JSON.stringify(parseData));
                    this.gettingResponse = x;

                }
            })
        }
        localStorage.setItem("isViewBool", JSON.stringify(false));
        return this.gettingResponse
    }

    public postTableSettings(tableSettingKey, body): Observable<any> {

        localStorage.removeItem(tableSettingKey + '-' + this.STORAGE_KEY);
        return this.http.post(environment.APIURL + 'filter', body);
    }

    public getLocalTableSettings(tableSettingKey): string {
        return localStorage.getItem(tableSettingKey + '-' + this.STORAGE_KEY);
    }

    public showLoader() {
        this.spinner.show();
    }
    public hideLoader() {
        this.spinner.hide();
    }

    filterOptions(value: string, optionsArr): any[] {
        if (!value) {
            return optionsArr;
        }
        const lowerCaseValue = value.toLowerCase();
        return optionsArr.filter(option => option.name.toLowerCase().includes(lowerCaseValue));
    }

    filterOption(value: string, optionsArr): any[] {
        if (!value) {
            return optionsArr;
        }
        const stringValue = value.toLowerCase();
        return optionsArr.filter(option => option.imei.toLowerCase().includes(stringValue));
    }


    downloadTemplate(fileUrl, savedName) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', fileUrl, true);
        xhr.responseType = 'blob';
        xhr.onload = function () {
            if (xhr.status === 200) {
                const blob = new Blob([xhr.response], { type: 'application/octet-stream' });
                saveAs(blob, savedName);
            }
        };
        xhr.send();
    }
    /**
  * Get Shipment Profile Data
 */
    getShipmentStatus(primaryReferenceNumber: string | null | number): Observable<any> {
        return this.http.get<any>(`${environment.APIV3}ShipmentProfile/ShipmentProfile?primaryReferenceNumber=${primaryReferenceNumber}`).pipe(
            tap((res) => {
                this.shipmentStatusDataSubject.next(res.data);
            })
        )
    }

    getShipmentProgressbarStructureData(primaryReferenceNumber: string | null | number) {
        return this.http.get<any>(`${environment.APIV3}Shipment/get-shipment-details?primaryReferenceNumber=${primaryReferenceNumber}`)

    }

    getShipmentProgreebarEvents(primaryReferenceNumber: string | null) {
        return this.http.get<any>(`${environment.APIV3}Shipment/get-shipment-events-details?primaryReferenceNumber=${primaryReferenceNumber}`)

    }

    getRefNumbers(url: string, params: any): Observable<any> {
        return this.http.get(environment.APIV3 + url, { params });
    }

    // e.g. GET /api/roles?email=you@company.com -> Role[]
    getUserRoles(url: string, email: string): Observable<IUserRolesResponse> {
        return this.http.get<IUserRolesResponse>(environment.APIURL + url, { params: { email } });
    }

    // -------------------------------- Newly added for column preset ----------------

    public enablePreset(body:any): Observable<any> {
        return this.http.post(environment.APIURL + 'tablefilter/enablepreset', body);
    }
    public checkPresetName(body:any): Observable<any> {
        return this.http.post(environment.APIURL + 'tablefilter/checkpresetname', body);
    }

    // Delete preset API
    public deletePresetRequest(url: string): Observable<any> {
        return this.http.delete(environment.APIURL + url);
    } 
    private getIsViewKey(pageReference: string): string {
        return `${pageReference}-isViewBool`;
    }
    private getJsonColumnDataKey(pageReference: string): string {
        return `${pageReference}-jsonColumnData`;
    }
}